// Idioma con el que arranca la web.
//
// Orden: 1) `?lang=es|en` en la URL; 2) el idioma que el visitante eligió con la bandera
// (localStorage `invokeapp_lang`, lo guardan AllContext y LandingNavbar); 3) español.
//
// Motivo: el revisor de Google necesita una URL directa a la política en inglés
// (https://invokeapp.io/privacy?lang=en). Antes la web arrancaba siempre en 'es' y el inglés
// solo se veía pulsando la bandera.
//
// `?lang=` se aplica a esa visita y NO se guarda: las páginas embebidas (/embed,
// /playbook-demo) también lo usan y no deben cambiar el idioma que el visitante eligió.
// Sin `window` (prerender en Node, tests) devuelve 'es', igual que antes.

export const SUPPORTED_LANGUAGES = ['es', 'en'];
export const DEFAULT_LANGUAGE = 'es';
export const LANGUAGE_STORAGE_KEY = 'invokeapp_lang';

export const normalizeLanguage = (value) => {
  if (typeof value !== 'string') return null;
  const code = value.trim().toLowerCase().slice(0, 2);
  return SUPPORTED_LANGUAGES.includes(code) ? code : null;
};

export const languageFromSearch = (search) => {
  if (typeof search !== 'string' || !search) return null;
  try {
    return normalizeLanguage(new URLSearchParams(search).get('lang'));
  } catch (e) {
    return null;
  }
};

const readStoredLanguage = (storage) => {
  try {
    return storage ? normalizeLanguage(storage.getItem(LANGUAGE_STORAGE_KEY)) : null;
  } catch (e) {
    // Navegación privada o almacenamiento bloqueado: se sigue sin él.
    return null;
  }
};

export const resolveInitialLanguage = ({ search, storage } = {}) => (
  languageFromSearch(search) || readStoredLanguage(storage) || DEFAULT_LANGUAGE
);

export const detectInitialLanguage = () => {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  let storage = null;
  try {
    storage = window.localStorage;
  } catch (e) {
    storage = null;
  }
  return resolveInitialLanguage({
    search: window.location ? window.location.search : '',
    storage,
  });
};

export default detectInitialLanguage;
